import {typeMessageState} from "../typesStore";

export const setMessage = (message: typeMessageState) => ({
    type: "SET_MESSAGE",
    value: message,
});
